import React from 'react';
import Modal from 'ds/components/modal';
import { Button } from 'ds/components/button';
import DoneIcon from 'assets/svg/done.svg';
import { Text } from 'ds/components/typography';
import * as Styled from 'screens/DeveloperPage/components/contact/styled';
import { useLocale } from 'locale';
import { SpacingBlock } from 'components/spacing-block';


interface SuccessModalProps {
  onClose: () => void;
}

export const SuccessInner: React.FC = () => {
  const { t } = useLocale();
  return (
    <Styled.SuccessWrapper>
      <DoneIcon data-auto="done-icon" width={60} height={60} />
      <Text weight="bold">{t('developerPage.contactModal.success')}</Text>
    </Styled.SuccessWrapper>
  );
};


export const SuccessModal: React.FC<SuccessModalProps> = ({ onClose }) => {
  const { t } = useLocale();
  return (
    <Modal
      isOpen
      onClose={onClose}
      mobileModalPositionBottom
    >
      <SuccessInner/>
      <SpacingBlock mTop={6}>
        <Button fullWidth size="extraLarge" onClick={onClose}>
          {t('developerPage.contactModal.successClose')}
        </Button>
      </SpacingBlock>
    </Modal>
  );
};
